import 'rxjs/add/operator/switchMap';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { Module } from '../../module/module';
import { Lecture } from '../../module/lecture/lecture';
import { Fixtures } from '../../fixtures';

@Component({
  selector: 'app-lecture',
  templateUrl: './lecture.component.html',
  styleUrls: ['./lecture.component.scss']
})
export class LectureComponent implements OnInit {

  lectures: Lecture[] = [];
  module: any;
  positionLection: number;

  constructor(
      private entities: Fixtures,
      private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.parent.params
        .switchMap((params: Params) => this.entities.modules.filter(module => {
            return +module.id === +params['id'];
        }))
        .subscribe((module) => {
            this.module = module;
            this.lectures = this.module.lectures;
        });

   this.route.params
       .switchMap((params: Params) => params['position'])
       .subscribe((position) => {
           this.positionLection = +position;
       });
  }

}




// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/module/lecture/lecture.component.ts